import styled from "@emotion/styled";

export const ItemContainer = styled.div``;
